import React, { Component } from 'react';
// import Header from './headerComponent';
import Type from './typed';

class Home extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="main">
                    {/* <Header/> */}
                    <Type/>
                </div>
            </React.Fragment>
        )
    }
}
export default Home